import { render } from "./TripPage.vue?vue&type=template&id=e0872734&scoped=true&ts=true"
import script from "./TripPage.vue?vue&type=script&lang=ts"
export * from "./TripPage.vue?vue&type=script&lang=ts"

import "./TripPage.vue?vue&type=style&index=0&id=e0872734&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0872734"]])

export default __exports__